export const LIVE_CASINO_MENUS = [
  {
    _id: '63c0e04f5b80bb950e64914f',
    component_content_id: '63806c8640b4a5aea422f02f',
    title: {
      'en-US': 'GSC SA GAMING',
      'th-TH': 'BIG',
      'vi-VN': '/',
      'zh-CN': 'WM Casino        ',
      'my-MM': ' '
    },
    description: {
      'en-US': 'GSC SA GAMING',
      'th-TH': 'BIG',
      'vi-VN': '/',
      'zh-CN': 'WM Casino        ',
      'my-MM': ' '
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 2379,
    game_provider_id: 35,
    sequence: 3,
    image_desktop_path: {
      'en-US': 'demo/games/live-casino/image-1-en.png',
      'th-TH': 'demo/games/live-casino/image-1-th.png',
      'zh-CN': 'demo/games/live-casino/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/live-casino/image-1-en-mobile.png',
      'th-TH': 'demo/games/live-casino/image-1-th-mobile.png',
      'zh-CN': 'demo/games/live-casino/image-1-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T04:38:39.813Z',
    updated_at: '2025-05-22T09:35:20.471Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: null,
    currency: 'thb',
    item_id: '63c0e04f5b80bb950e64914f'
  },
  {
    _id: '63c0df675b80bb950e649120',
    component_content_id: '63806c8640b4a5aea422f02f',
    title: {
      'en-US': 'all bet',
      'th-TH': 'EVOLOUTION',
      'zh-CN': 'Sexy Gaming        '
    },
    description: {
      'en-US': 'all bet',
      'th-TH': 'EVOLOUTION',
      'zh-CN': 'Sexy Gaming        '
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 3484,
    game_provider_id: 46,
    sequence: 5,
    image_desktop_path: {
      'en-US': 'demo/games/live-casino/image-2-en.png',
      'th-TH': 'demo/games/live-casino/image-2-th.png',
      'zh-CN': 'demo/games/live-casino/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/live-casino/image-2-en-mobile.png',
      'th-TH': 'demo/games/live-casino/image-2-th-mobile.png',
      'zh-CN': 'demo/games/live-casino/image-2-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T04:34:47.379Z',
    updated_at: '2025-05-22T09:35:27.527Z'
  },
  {
    _id: '65cb1a01f3707c38cb5d6fa9',
    component_content_id: '63806c8640b4a5aea422f02f',
    title: {
      'en-US': 'test',
      'th-TH': 'GREEN DRAGON',
      'vi-VN': '/',
      'zh-CN': 'Test',
      'my-MM': ' '
    },
    description: {
      'en-US': 'test',
      'th-TH': 'GREEN DRAGON',
      'vi-VN': '/',
      'zh-CN': 'test',
      'my-MM': ' '
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 4322,
    game_provider_id: 51,
    sequence: 6,
    image_desktop_path: {
      'en-US': 'demo/games/live-casino/image-3-en.png',
      'th-TH': 'demo/games/live-casino/image-3-th.png',
      'zh-CN': 'demo/games/live-casino/image-3-ch.png'
    },
    __v: 0,
    created_at: '2024-02-13T07:28:01.659Z',
    updated_at: '2025-05-22T09:35:33.028Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    },
    link: null,
    image_mobile_path: {
      'en-US': 'demo/games/live-casino/image-3-en-mobile.png',
      'th-TH': 'demo/games/live-casino/image-3-th-mobile.png',
      'zh-CN': 'demo/games/live-casino/image-3-ch-mobile.png'
    }
  },
  {
    _id: '65fbaac87f2d6fc24bfc7287',
    component_content_id: '63806c8640b4a5aea422f02f',
    title: {
      'en-US': 'SexyGamingBaccarat 1SexyGamingBaccarat 1',
      'th-TH': 'ION',
      'vi-VN': 'SexyGamingBaccarat 1',
      'zh-CN': 'SexyGamingBaccarat 1'
    },
    description: {
      'en-US': 'SexyGamingBaccarat 1',
      'th-TH': 'ION',
      'vi-VN': 'SexyGamingBaccarat 1',
      'zh-CN': 'Live casino'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 3054,
    game_provider_id: 41,
    sequence: 7,
    image_desktop_path: {
      'en-US': 'demo/games/live-casino/image-4-en.png',
      'th-TH': 'demo/games/live-casino/image-4-th.png',
      'zh-CN': 'demo/games/live-casino/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/live-casino/image-4-en-mobile.png',
      'th-TH': 'demo/games/live-casino/image-4-th-mobile.png',
      'zh-CN': 'demo/games/live-casino/image-4-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-03-21T03:34:32.417Z',
    updated_at: '2025-05-22T06:30:15.390Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '6617aab0d8f91781b7cf923f',
    component_content_id: '63806c8640b4a5aea422f02f',
    title: {
      'en-US': 'blackjack',
      'th-TH': 'PRAGMATICPLAY',
      'vi-VN': 'blackjack',
      'zh-CN': 'black jack'
    },
    description: {
      'en-US': 'blackjack',
      'th-TH': 'PRAGMATICPLAY',
      'vi-VN': 'blackjack',
      'zh-CN': 'black jack'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 10046,
    game_provider_id: 99,
    sequence: 8,
    image_desktop_path: {
      'en-US': 'demo/games/live-casino/image-5-en.png',
      'th-TH': 'demo/games/live-casino/image-5-th.png',
      'zh-CN': 'demo/games/live-casino/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/live-casino/image-5-en-mobile.png',
      'th-TH': 'demo/games/live-casino/image-5-th-mobile.png',
      'zh-CN': 'demo/games/live-casino/image-5-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-04-11T09:17:36.742Z',
    updated_at: '2025-05-22T06:30:15.398Z',
    image_path: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  }
]
